module.exports = __webpack_public_path__ + "img/11.d26f8c68.jpg";